import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { t } from "ttag";
import { useStoreActions } from "../../models/RootStore";
import { localXhr } from "../../services/localXhr";

export default function LogOut(props: any) {
  const [open, setOpen] = React.useState(false);

  const logout = useStoreActions((actions) => actions.users.logout);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAgree = () => {
    logout();
    window.location.reload();
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>{t`Log out`}</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t`Log out`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t`Are you sure you want to log-out?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t`No`}</Button>
          <Button onClick={handleAgree} autoFocus={true}>
            {t`Yes`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
